import React from 'react';
import cls from 'classnames';

import { SKButton, ButtonSizes } from '../Button/index';
import { FAQItem } from '../FAQItem';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../constants/routes';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

export interface Question {
  title: string;
  answer: string; //posibly this type will be extended to accept nested components inside the answer.
}

export interface IFaq {
  background: 'kiwi' | 'pomelo' | 'white' | 'lemon' | 'grape' | 'cloud';
  hasButton: boolean;
  title?: string;
  questions: Question[];
}

export const Faq: React.FC<IFaq> = (props) => {
  const { background, title, questions, hasButton } = props;
  const history = useHistory();
  const isBiggerThanMobile = useBreakpoint('48em');

  return (
    <div
      className={cls({
        'bg-pomelo-400': background === 'pomelo',
        'bg-lemon-400': background === 'lemon',
        'bg-grape-500': background === 'grape',
        'bg-kiwi-400': background === 'kiwi',
        'bg-cloud-800': background === 'cloud',
      })}
    >
      <div className="app-container mx-auto px-1 xs-only:px-2 md:px-2 lg:max-w-71.5 pb-9 min-h-40 w-full">
        {title && (
          <div className="flex items-center justify-center">
            <h4 className="text-cloud-900 text-display-lg font-normal my-9">{title}</h4>
          </div>
        )}
        <ul className="w-full mb-9">
          {questions.map((question, index) => (
            <li key={index}>
              <FAQItem question={question} />
            </li>
          ))}
        </ul>
        {hasButton && (
          <div className="flex items-center justify-center">
            <SKButton
              color={'tertiary'}
              size={isBiggerThanMobile ? ButtonSizes.XXL : ButtonSizes.XL}
              onClick={(): void => history.push(Routes.FAQ)}
              label="More FAQ"
            >
              More FAQ
            </SKButton>
          </div>
        )}
      </div>
    </div>
  );
};
